export function initAuth(store) {
    return new Promise((resolve, reject) => {
        if (store.getters["user/isLoggedIn"] === true) {
            resolve();
            return;
        }
        let auth = JSON.parse(localStorage.getItem("auth"));

        if (auth === null) {
            reject();
            return;
        }

        store.commit("user/auth", auth);
        store
            .dispatch("user/userinfo")
            .then(() => {
                resolve();
            })
            .catch(error => {
                store.dispatch("user/logout");
                reject(error);
            });
    });
}
export function pushInterceptor(http, store, router) {
    http.interceptors.push((request, next) => {
        if(request.url.includes('transaction')){
           store.dispatch("app/loader", false);
        }
        if(!request.url.includes('addresses') && !request.url.includes('transaction')){
           store.dispatch("app/loader", true);
        }
        if (store.getters["user/isLoggedIn"]) {
            request.headers.set(
                "Authorization",
                "Bearer " + store.getters["user/accessToken"]
            );
            request.headers.set("Accept", "application/json");
        }
        next(response => {
            let tokenRefreshNeeded =
                response.status === 401 &&
                response.url.indexOf("/api/v1/login") === -1 &&
                response.url.indexOf("/api/v1/refresh") === -1;

            if (!tokenRefreshNeeded) {
                store.dispatch("app/loader", false);
                return;
            }

            return new Promise((resolve, reject) => {
                store.dispatch("user/refresh").then(
                    () => {
                        if (request.url.indexOf("/api/v1/userinfo") === -1) {
                            store.dispatch("user/userinfo");
                        }
                        store.dispatch("app/loader", false);
                        resolve(http(request));
                    },
                    error => {
                        router.replace({ name: "login" });
                        store.dispatch("app/loader", false);
                        reject(error);
                    }
                );
            });
        });
    });
}
